export const dbFields =
{
    id: {
        visiable: false,
        title: 'Imei',
        key: 'imei'
    },
    imei: {
        visiable: false,
        title: 'IMEI',
        key: 'imei'
    },
    custom_id: {
        visiable: true,
        title: 'Customer ID',
        key: 'custom_id'
    },
    devos_id: {
        visiable: true,
        title: 'DevosId',
        key: 'devos_id'
    },
    curef: {
        visiable: true,
        title: 'CU Ref',
        key: 'curef'
    },
    device_info: {
        visiable: true,
        title: 'Device_info',
        key: 'device_info'
    },
    wifi_mac: {
        visiable: true,
        title: 'WiFi MAC',
        key: 'wifi_mac'
    },
    imei2: {
        visiable: true,
        title: 'Imei2',
        key: 'imei2'
    },
    device_id: {
        visiable: true,
        title: 'DeviceId',
        key: 'device_id'
    },
    imsi1: {
        visiable: true,
        title: 'Imsi1',
        key: 'imsi1'
    },
    imsi2: {
        visiable: true,
        title: 'Imsi2',
        key: 'imsi2'
    },
    endpoints: {
        visiable: true,
        title: 'Endpoints',
        key: 'endpoints'
    },
    activation_date: {
        visiable: true,
        title: 'Activation Date',
        key: 'activation_date'
    },
    last_check_online: {
        visiable: true,
        title: 'LastCheckOnline',
        key: 'last_check_online'
    },
};
